import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrganizationList, SeniorCenter } from '@app/models/organization.model';
import { CustomSelectorValue } from '@app/models';

@Component({
    selector: 'app-senior-center-selector',
    templateUrl: './senior-center-selector.component.html',
    styleUrls: ['./senior-center-selector.component.scss'],
    standalone: false
})
export class SeniorCenterSelectorComponent implements OnInit {

  @Input('organizationData') organizationData!: OrganizationList;
  @Input('selectedSeniorCenterData') selectedSeniorCenterData: SeniorCenter | null = null;
  @Input('isOrgLevel') isOrgLevel: boolean = false;
  @Input('extraOptions') extraOptions: CustomSelectorValue<SeniorCenter | 0>[] = [];
  @Output('centerChange') centerChange: EventEmitter<SeniorCenter | null> = new EventEmitter<SeniorCenter | null>();

  constructor() { }

  ngOnInit(): void {
    // no initial operations required
  }

  changeValue(value: SeniorCenter | null) {
    this.centerChange.emit(value);
  }

}
